import styled from "styled-components";
import {
  Card,
  Button as AntButton,
  Table as AntTable,
  Progress as AntProgress,
  Select as SelectAnt,
} from "antd";
import {
  SearchOutlined,
  ArrowLeftOutlined,
  PlayCircleOutlined,
  FileTextOutlined,
  FormOutlined,
} from "@ant-design/icons";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  .ant-table-pagination.ant-pagination,
  .ant-table-pagination.ant-pagination,
  .ant-table-pagination.ant-pagination {
    background-color: transparent !important;
  }

  .ant-collapse-header {
    padding: 0.3rem !important;
    border: none !important;
    background-color: var(--gray-50) !important;
    border-radius: 0.2rem 0.2rem 0 0 !important;
    color: #787878 !important;
  }

  .ant-collapse-ghost
    > .ant-collapse-item
    > .ant-collapse-content
    > .ant-collapse-content-box {
    background-color: var(--gray-50) !important;
    border-radius: 0 0 0.2rem 0.2rem;
    color: #787878 !important;
    padding: 0rem 1rem 0.5rem 1rem !important;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const HeaderList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  color: var(--gray-800);
`;

export const SearchContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  width: 100%;

  .ant-input-affix-wrapper {
    border-radius: 0.25rem;
    border: 0.0625rem solid rgba(205, 207, 213, 0.5);
  }

  @media (max-width: 992px) {
    width: 100%;

    .ant-input-affix-wrapper {
      width: 100% !important;
    }
  }

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const Select = styled(SelectAnt)`
  width: 10rem;
  border: 0.0625rem solid rgba(205, 207, 213, 0.5);
  .ant-select-arrow {
    color: var(--gray-550);
  }
  .ant-select-selector {
    height: 100% !important;
  }

  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const Content = styled.div``;

export const ContainerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const CourseCard = styled(Card)`
  height: 100%;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;

  .ant-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0.3rem 1.5rem;

    gap: 0.2rem;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-3px);
  }

  p {
    color: var(--gray-600);
    flex-grow: 1;
  }
`;

export const CourseName = styled.span`
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--black-opaco);

  cursor: pointer;
`;

export const Button = styled(AntButton)`
  background-color: var(--orange-150);
  color: var(--white);
  border-radius: 0.2rem;
  border: none;
  &:hover,
  &:focus,
  &:active,
  &:focus-within {
    background-color: var(--orange-250);
    color: var(--white);
  }
`;

export const CourseDescription = styled.div`
  height: 3rem;
  overflow: auto;
  text-overflow: ellipsis;
  color: var(--gray-600);
  display: -webkit-box;

  cursor: pointer;
`;

export const CourseInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ant-tag {
  }
`;

export const BoxPanel = styled.div`
  height: 6rem;
`;

export const UserCount = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--gray-600);

  .anticon {
    color: var(--primary);
  }
`;

export const ActivityItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
`;

export const ActivityContainer = styled.div`
  max-height: 80px;
  overflow-y: auto;
`;

export const CourseActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;

  button {
    flex: 1;
  }
`;

export const BackButton = styled(AntButton)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StudentsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const CourseTitle = styled.span`
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--gray-800);
`;

export const StudentsCount = styled.div`
  font-size: 1rem;
  color: #787878;
`;

export const StudentsList = styled.div``;

export const Table = styled(AntTable)`
  .ant-table {
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .ant-table-thead > tr > th {
    background-color: var(--gray-100);
    color: var(--gray-800);
  }
`;

export const Progress = styled(AntProgress)`
  .ant-progress-text {
    font-size: 0.85rem;
  }
`;

export const LoadingContainer = styled.div`
  text-align: center;
  color: var(--gray-600);
`;

export const ArrowLeft = styled(ArrowLeftOutlined)`
  cursor: pointer;
  font-size: 1.2rem;
  color: var(--primary);
  &&&:hover {
    color: var(--orange-250);
  }
`;

export const Search = styled(SearchOutlined)`
  cursor: pointer;
  color: var(--gray-600);
`;

export const PlayCircle = styled(PlayCircleOutlined)`
  cursor: pointer;
  color: #1890ff;
`;

export const FileText = styled(FileTextOutlined)`
  cursor: pointer;
  color: #ff4d4f;
`;

export const Form = styled(FormOutlined)`
  cursor: pointer;
  color: #52c41a;
`;
